import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../../../models'
import { daMetricNames } from './da-metric-names'

export const daAdgroupMetricNames: Array<TGlobalMetrics> = daMetricNames.filter(
  (header) =>
    !(
      header === EReportColumnHeader.Carts ||
      header === EReportColumnHeader.Purchases ||
      header === EReportColumnHeader.Revenue ||
      header === EReportColumnHeader.Roas
    )
)
